import React from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { useRef } from "react";

function Section({
  title,
  language,
  content,
  callback,
  callbackText = null,
  surface = false,
}) {
  const titleStyle = {
    marginBottom: 8,
    fontWeight: "bold",
    color: "#333",
    padding: "0px 10px",
    fontSize: "20px",
  };
  return (
    <div className="mb-4 mt-4">
      {title && (
        <>
          <div className={" mb-0 px-1 pb-2 pt-4 "} onClick={() => {}}>
            <h5
              className={`px-0 mx-0 ${
                language == "arabic" ? "text-right" : "text-left"
              }`}
              style={{
                fontFamily: language == "arabic" ? "Cairo" : "Quicksand",
              }}
            >
              <span
                className="mx-0"
                style={{
                  ...titleStyle,
                  textAlign: language === "arabic" ? "right" : "left",
                }}
              >
                {title}
              </span>
              {callbackText && (
                <span
                  className={`${
                    language === "arabic" ? "float-left" : "float-right"
                  }`}
                  onClick={callback}
                >
                  {callbackText}
                </span>
              )}
            </h5>
          </div>
        </>
      )}

      <div
        id={"nav"}
        className="card"
        style={{
          border: 0,
          borderRadius: 0,
          height: "auto",
          minHeight: 100,
          width: "100%",
          marginBottom: 0,
          backgroundColor: surface ? "#fff" : "transparent",
          borderTop: surface ? "1px solid #dedede" : 0,
          borderBottom: surface ? "1px solid #dedede" : 0,
          padding: surface ? "16px 0px" : "0px",
        }}
      >
        {surface} {content}
      </div>
    </div>
  );
}

export default Section;
